import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/new-design/images/chevron-left-link.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-6ddc050a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navigator-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "back"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      class: "navigator-link",
      to: _ctx.to
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createTextVNode(" " + _toDisplayString(_ctx.text), 1)
      ]),
      _: 1
    }, 8, ["to"])
  ]))
}